import store from '@state/store'

const authRoutes = [
  {
    path: '/',
    name: 'login',
    component: () => lazyLoadView(import('@views/pages/account/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['users/get_loggedIn']) {
          next({ name: 'dashboard' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => lazyLoadView(import('@views/pages/account/register')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['users/loggedIn']) {
          next({ name: 'Dashboard' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/forget-password',
    name: 'forget-password',
    component: () =>
      lazyLoadView(import('@views/pages/account/forgetPassword')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['users/get_loggedIn']) {
          next({ name: 'Dashboard' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        await store.dispatch('sessions/FETCH_SESSIONS_DELETE')
        window.location.href = '/'
      },
    },
  },
]

const accountRoutes = [
  {
    path: '/account',
    header: 'Аккаунт',
    icon: 'home',
    props: (route) => ({ user: store.state.users.USER_ITEM || {} }),
    meta: { authRequired: true, adminRequired: false },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: '/',
        name: 'Account',
        title: 'Дашборд',
        component: () => lazyLoadView(import('@views/pages/dashboard/index')),
      },

      {
        path: 'dashboard',
        name: 'Dashboard',
        title: 'Дашборд',
        component: () => lazyLoadView(import('@views/pages/dashboard/index')),
      },

      {
        path: 'companies',
        name: 'Companies',
        title: 'Компании',
        component: () => lazyLoadView(import('@views/pages/companies/index')),
      },
      {
        path: 'companies/create',
        name: 'Companies.create',
        title: 'Новая компания',
        component: () => lazyLoadView(import('@views/pages/companies/form')),
      },
      {
        path: 'companies/:company_uuid/edit',
        name: 'Companies.edit',
        title: 'Редактирование информации о компании',
        component: () => lazyLoadView(import('@views/pages/companies/form')),
      },

      {
        path: 'users/accounts',
        name: 'Users.Accounts',
        title: 'Аккаунты',
        component: () => lazyLoadView(import('@views/pages/accounts/index')),
      },
      {
        path: 'users/accounts/create',
        name: 'Users.Accounts.create',
        title: 'Новый аккаунт',
        component: () => lazyLoadView(import('@views/pages/accounts/form')),
      },
      {
        path: 'users/accounts/:account_uuid/edit',
        name: 'Users.Accounts.edit',
        title: 'Редактирование аккаунта',
        component: () => lazyLoadView(import('@views/pages/accounts/form')),
      },

      {
        path: 'profile',
        name: 'Profile',
        title: 'Профиль пользователя',
        component: () => lazyLoadView(import('@views/pages/profile/form')),
      },

      {
        path: 'settings',
        name: 'Settings',
        title: 'Настройки',
        component: () => lazyLoadView(import('@views/pages/settings/form')),
      },

      {
        path: 'finance/:type',
        name: 'Finance',
        title: 'Финансовые операции',
        component: () => lazyLoadView(import('@views/pages/finance/index')),
      },

      {
        path: 'documents/:type',
        name: 'Documents',
        title: 'Документы',
        component: () => lazyLoadView(import('@views/pages/documents/index')),
      },

      {
        path: 'payments/create',
        name: 'Payments.create',
        title: 'Пополнение счета',
        component: () => lazyLoadView(import('@views/pages/payments/form')),
      },
      {
        path: 'payments/:document_uuid/edit',
        name: 'Payments.edit',
        title: 'Редактирование платежа',
        component: () => lazyLoadView(import('@views/pages/payments/form')),
      },

      {
        path: 'users',
        name: 'Users',
        title: 'Пользователи',
        component: () => lazyLoadView(import('@views/pages/users/index')),
      },
      {
        path: 'users/create',
        name: 'Users.create',
        title: 'Новый пользователь',
        component: () => lazyLoadView(import('@views/pages/users/form')),
      },
      {
        path: 'users/:user_uuid/edit',
        name: 'Users.edit',
        title: 'Редактирование информации о пользователе',
        component: () => lazyLoadView(import('@views/pages/users/form')),
      },

      {
        path: 'knowledge',
        name: 'Knowledge',
        title: 'Базы знаний',
        component: () => lazyLoadView(import('@views/pages/knowledge/index')),
      },
      {
        path: 'knowledge/create',
        name: 'Knowledge.create',
        title: 'Новая база знаний',
        component: () => lazyLoadView(import('@views/pages/knowledge/form')),
      },
      {
        path: 'knowledge/:knowledge_uuid/edit',
        name: 'Knowledge.edit',
        title: 'Редактирование базы знаний',
        component: () => lazyLoadView(import('@views/pages/knowledge/form')),
      },

      {
        path: 'calls',
        name: 'Calls',
        title: 'Статистика звонков',
        component: () => lazyLoadView(import('@views/pages/calls/index')),
      },

      {
        path: 'contacts/blacklist',
        name: 'Contacts.Blacklist',
        title: 'Черный список',
        component: () =>
          lazyLoadView(import('@views/pages/contacts/blacklist/index')),
      },
      {
        path: 'contacts/blacklist/create',
        name: 'Contacts.Blacklist.create',
        title: 'Блокировка контакта',
        component: () =>
          lazyLoadView(import('@views/pages/contacts/blacklist/form')),
      },
      {
        path: 'contacts/blacklist/:contact_blacklist_uuid/edit',
        name: 'Contacts.Blacklist.edit',
        title: 'Блокировка контакта',
        component: () =>
          lazyLoadView(import('@views/pages/contacts/blacklist/form')),
      },

      {
        path: 'contacts/categories',
        name: 'Contacts.Categories',
        title: 'Группы контактов',
        component: () =>
          lazyLoadView(import('@views/pages/contacts/categories/index')),
      },
      {
        path: 'contacts/categories/create',
        name: 'Contacts.Category.create',
        title: 'Новая группа',
        component: () =>
          lazyLoadView(import('@views/pages/contacts/categories/form')),
      },
      {
        path: 'contacts/categories/:category_uuid/edit',
        name: 'Contacts.Category.edit',
        title: 'Редактирование группы',
        component: () =>
          lazyLoadView(import('@views/pages/contacts/categories/form')),
      },

      {
        path: 'contacts',
        name: 'Contacts',
        title: 'Контакты',
        component: () => lazyLoadView(import('@views/pages/contacts/index')),
      },
      {
        path: 'contacts/import',
        name: 'Contacts.import',
        title: 'Импорт контактов',
        component: () => lazyLoadView(import('@views/pages/contacts/import')),
      },
      {
        path: 'contacts/create',
        name: 'Contacts.create',
        title: 'Новый контакт',
        component: () => lazyLoadView(import('@views/pages/contacts/form')),
      },
      {
        path: 'contacts/groups/:status',
        name: 'Contacts.filter',
        title: 'Контакты',
        component: () => lazyLoadView(import('@views/pages/contacts/index')),
      },
      {
        path: 'contacts/:contact_uuid/edit',
        name: 'Contacts.edit',
        title: 'Редактирование контакта',
        component: () => lazyLoadView(import('@views/pages/contacts/form')),
      },

      {
        path: 'bots',
        name: 'Bots',
        title: 'Боты',
        component: () => lazyLoadView(import('@views/pages/bots/index')),
      },
      {
        path: 'bots/create',
        name: 'Bots.create',
        title: 'Новый бот',
        component: () => lazyLoadView(import('@views/pages/bots/form')),
      },
      {
        // Диалоговый кэш бота (только админ): дерево фраз llm_cache/audio_cache + прослушка
        path: 'bots/:uuid/dialog-cache',
        name: 'Bots.dialogCache',
        title: 'Диалоговый кэш',
        meta: { authRequired: true, adminRequired: true },
        component: () => lazyLoadView(import('@views/pages/bots/dialog-cache')),
      },
      {
        path: 'bots/:bot_uuid/edit',
        name: 'Bots.edit',
        title: 'Редактирование бота',
        component: () => lazyLoadView(import('@views/pages/bots/form')),
      },

      {
        path: 'pricing',
        name: 'Pricing',
        title: 'Тарифы',
        component: () => lazyLoadView(import('@views/pages/pricing/index')),
      },

      {
        path: 'skills',
        name: 'Skills',
        title: 'Навыки',
        component: () => lazyLoadView(import('@views/pages/skills/index')),
      },
      // {
      //   path: 'skills/create',
      //   name: 'Skills.create',
      //   title: 'Новый навык',
      //   component: () => lazyLoadView(import('@views/pages/skills/form')),
      // },
      // {
      //   path: 'skills/:skill_uuid/edit',
      //   name: 'Skills.edit',
      //   title: 'Редактирование навыка',
      //   component: () => lazyLoadView(import('@views/pages/skills/form')),
      // },
      {
        path: 'mindmap',
        name: 'Mindmap',
        title: 'Редактор сценария',
        component: () => lazyLoadView(import('@views/pages/mindmap/index')),
      },

      {
        path: 'mindmap/edit/:type/:uuid',
        name: 'Mindmap.edit',
        title: 'Редактор сценария',
        component: () => lazyLoadView(import('@views/pages/mindmap/index')),
      },

      {
        path: 'dictionaries',
        name: 'Dictionaries',
        title: 'Словари',
        component: () =>
          lazyLoadView(import('@views/pages/dictionaries/index')),
      },
      {
        path: 'dictionaries/create',
        name: 'Dictionaries.create',
        title: 'Новый словарь',
        component: () => lazyLoadView(import('@views/pages/dictionaries/form')),
      },
      {
        path: 'dictionaries/:dictionary_uuid/edit',
        name: 'Dictionaries.edit',
        title: 'Редактирование словаря',
        component: () => lazyLoadView(import('@views/pages/dictionaries/form')),
      },

      {
        path: 'tasks',
        name: 'Tasks',
        title: 'Задачи',
        component: () => lazyLoadView(import('@views/pages/tasks/index')),
      },
      {
        path: 'tasks/create',
        name: 'Tasks.create',
        title: 'Новая задача',
        component: () => lazyLoadView(import('@views/pages/tasks/form')),
      },
      {
        path: 'tasks/:task_uuid/edit',
        name: 'Tasks.edit',
        title: 'Редактирование задачи',
        component: () => lazyLoadView(import('@views/pages/tasks/form')),
      },

      {
        path: 'dialogs',
        name: 'Dialogs',
        title: 'Обращения',
        component: () => lazyLoadView(import('@views/pages/dialogs/index')),
      },

      {
        path: 'dialogs/groups/:status',
        name: 'Dialogs',
        title: 'Архив обращений',
        component: () => lazyLoadView(import('@views/pages/dialogs/index')),
      },

      {
        path: 'dialogs/:dialog_uuid',
        name: 'Dialogs.item',
        title: 'Обращение',
        component: () => lazyLoadView(import('@views/pages/dialogs/item')),
      },

      {
        path: 'integrations',
        name: 'Integrations',
        title: 'Интеграции',
        component: () =>
          lazyLoadView(import('@views/pages/integrations/index')),
      },
      {
        path: 'integrations/create',
        name: 'Integrations.create',
        title: 'Новая интеграция',
        component: () => lazyLoadView(import('@views/pages/integrations/form')),
      },
      {
        path: 'integrations/:integration_uuid/edit',
        name: 'Integrations.edit',
        title: 'Редактирование интеграции',
        component: () => lazyLoadView(import('@views/pages/integrations/form')),
      },

      {
        path: 'trunks',
        name: 'Trunks',
        title: 'Транки',
        component: () => lazyLoadView(import('@views/pages/trunks/index')),
      },
      {
        path: 'trunks/phones',
        name: 'Trunks.Phones',
        title: 'Телефонные номера',
        component: () =>
          lazyLoadView(import('@views/pages/trunks/phones/index')),
      },

      {
        path: 'imports/contacts',
        name: 'Imports.Contacts',
        title: 'Импорт контактов',
        component: () =>
          lazyLoadView(import('@views/pages/imports/contacts/index')),
      },
      {
        path: 'reports',
        name: 'Reports',
        title: 'Отчеты',
        component: () =>
          lazyLoadView(import('@views/pages/reports/index')),
      },
      {
        path: 'reports/create',
        name: 'Reports.create',
        title: 'Новый отчет',
        component: () => lazyLoadView(import('@views/pages/reports/form')),
      },
      {
        path: 'reports/:report_uuid/edit',
        name: 'Reports.edit',
        title: 'Редактирование отчета',
        component: () => lazyLoadView(import('@views/pages/reports/form')),
      },
    ],
  },
]

const adminRoutes = [
  {
    path: '/account',
    header: 'Аккаунт',
    icon: 'home',
    props: (route) => ({ user: store.state.users.USER_ITEM || {} }),
    meta: { authRequired: true, adminRequired: true },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    children: [
      {
        path: 'economy',
        name: 'Economy',
        title: 'Экономика',
        component: () => lazyLoadView(import('@views/pages/economy/index')),
      },
      {
        path: 'actions',
        name: 'Actions',
        title: 'Функции ботов',
        component: () => lazyLoadView(import('@views/pages/actions/index')),
      },
      {
        path: 'actions/create',
        name: 'Actions.create',
        title: 'Новая функция',
        component: () => lazyLoadView(import('@views/pages/actions/form')),
      },
      {
        path: 'actions/:action_uuid/edit',
        name: 'Actions.edit',
        title: 'Редактирование функции',
        component: () => lazyLoadView(import('@views/pages/actions/form')),
      },

      {
        path: 'languages',
        name: 'Languages',
        title: 'Языки коммуникаций',
        component: () => lazyLoadView(import('@views/pages/languages/index')),
      },
      {
        path: 'languages/create',
        name: 'Languages.create',
        title: 'Новый язык коммуникаций',
        component: () => lazyLoadView(import('@views/pages/languages/form')),
      },
      {
        path: 'languages/:language_uuid/edit',
        name: 'Languages.edit',
        title: 'Редактирование языка коммуникаций',
        component: () => lazyLoadView(import('@views/pages/languages/form')),
      },

      {
        path: 'products',
        name: 'Products',
        title: 'Услуги',
        component: () => lazyLoadView(import('@views/pages/products/index')),
      },
      {
        path: 'products/create',
        name: 'Products.create',
        title: 'Новая услуга',
        component: () => lazyLoadView(import('@views/pages/products/form')),
      },
      {
        path: 'products/:product_uuid/edit',
        name: 'Products.edit',
        title: 'Редактирование услуги',
        component: () => lazyLoadView(import('@views/pages/products/form')),
      },

      {
        path: 'operators/tariffs',
        name: 'Operators.Tariffs',
        title: 'Тарифы услуг операторов',
        component: () => lazyLoadView(import('@views/pages/operators/tariffs/index')),
      },
      {
        path: 'operators/tariffs/create',
        name: 'Operators.Tariffs.create',
        title: 'Новая услуга оператора',
        component: () => lazyLoadView(import('@views/pages/operators/tariffs/form')),
      },
      {
        path: 'operators/tariffs/:operator_tariff_uuid/edit',
        name: 'Operators.Tariffs.edit',
        title: 'Редактирование услуги оператора',
        component: () => lazyLoadView(import('@views/pages/operators/tariffs/form')),
      },


      {
        path: 'operators',
        name: 'Operators',
        title: 'Операторы',
        component: () => lazyLoadView(import('@views/pages/operators/index')),
      },
      {
        path: 'operators/create',
        name: 'Operators.create',
        title: 'Новый оператор',
        component: () => lazyLoadView(import('@views/pages/operators/form')),
      },
      {
        path: 'operators/:operator_uuid/edit',
        name: 'Operators.edit',
        title: 'Редактирование оператора',
        component: () => lazyLoadView(import('@views/pages/operators/form')),
      },

      {
        path: 'channels',
        name: 'Channels',
        title: 'Каналы коммуникаций',
        component: () => lazyLoadView(import('@views/pages/channels/index')),
      },
      {
        path: 'channels/create',
        name: 'Channels.create',
        title: 'Новый канал коммуникаций',
        component: () => lazyLoadView(import('@views/pages/channels/form')),
      },
      {
        path: 'channels/:channel_uuid/edit',
        name: 'Channels.edit',
        title: 'Редактирование канала коммуникаций',
        component: () => lazyLoadView(import('@views/pages/channels/form')),
      },

      {
        path: 'servers',
        name: 'Servers',
        title: 'Серверы',
        component: () => lazyLoadView(import('@views/pages/servers/index')),
      },
      {
        path: 'servers/create',
        name: 'Servers.create',
        title: 'Новый сервер',
        component: () => lazyLoadView(import('@views/pages/servers/form')),
      },
      {
        path: 'servers/:server_uuid/edit',
        name: 'Servers.edit',
        title: 'Настройки сервера',
        component: () => lazyLoadView(import('@views/pages/servers/form')),
      },

      {
        path: 'trunks/create',
        name: 'Trunks.create',
        title: 'Новый транк',
        component: () => lazyLoadView(import('@views/pages/trunks/form')),
      },      
      {
        path: 'trunks/:trunk_uuid/edit',
        name: 'Trunks.edit',
        title: 'Редактирование транка',
        component: () => lazyLoadView(import('@views/pages/trunks/form')),
      },

      {
        path: 'trunks/phones/create',
        name: 'Trunks.Phones.create',
        title: 'Новый телефонный номер',
        component: () =>
          lazyLoadView(import('@views/pages/trunks/phones/form')),
      },
      {
        path: 'trunks/phones/:trunk_phone_uuid/edit',
        name: 'Trunks.Phones.edit',
        title: 'Редактирование телефонного номера',
        component: () =>
          lazyLoadView(import('@views/pages/trunks/phones/form')),
      },

      {
        path: 'tariffs',
        name: 'Tariffs',
        title: 'Тарифы',
        component: () => lazyLoadView(import('@views/pages/tariffs/index')),
      },
      {
        path: 'tariffs/create',
        name: 'Tariffs.create',
        title: 'Новый тариф',
        component: () => lazyLoadView(import('@views/pages/tariffs/form')),
      },
      {
        path: 'tariffs/:tariff_uuid/edit',
        name: 'Tariffs.edit',
        title: 'Редактирование тарифа',
        component: () => lazyLoadView(import('@views/pages/tariffs/form')),
      },


      {
        path: 'countries',
        name: 'Countries',
        title: 'Страны',
        component: () => lazyLoadView(import('@views/pages/countries/index')),
      },
      {
        path: 'countries/create',
        name: 'Countries.create',
        title: 'Новая страна',
        component: () => lazyLoadView(import('@views/pages/countries/form')),
      },
      {
        path: 'countries/:uuid/edit',
        name: 'Countries.edit',
        title: 'Редактирование страны',
        component: () => lazyLoadView(import('@views/pages/countries/form')),
      },

      {
        path: 'regions',
        name: 'Regions',
        title: 'Регионы',
        component: () => lazyLoadView(import('@views/pages/regions/index')),
      },
      {
        path: 'regions/create',
        name: 'Regions.create',
        title: 'Новый регион',
        component: () => lazyLoadView(import('@views/pages/regions/form')),
      },
      {
        path: 'regions/:uuid/edit',
        name: 'Regions.edit',
        title: 'Редактирование региона',
        component: () => lazyLoadView(import('@views/pages/regions/form')),
      },

      {
        path: 'phones/codes',
        name: 'Phones.Codes',
        title: 'Коды номеров',
        component: () => lazyLoadView(import('@views/pages/phones/codes/index')),
      },
      {
        path: 'phones/codes/create',
        name: 'Phones.Codes.create',
        title: 'Новые коды',
        component: () => lazyLoadView(import('@views/pages/phones/codes/form')),
      },
      {
        path: 'phones/codes/:uuid/edit',
        name: 'Phones.Codes.edit',
        title: 'Редактирование кодов',
        component: () => lazyLoadView(import('@views/pages/phones/codes/form')),
      },

    ],
  },
]

const authProtectedRoutes = [...accountRoutes, ...adminRoutes]

const allRoutes = [...authRoutes, ...authProtectedRoutes]

export { allRoutes, authProtectedRoutes }

function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    loading: require('@components/_loading').default,
    delay: 400,
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      return h(AsyncHandler, data, children)
    },
  })
}
